import { Subject } from 'rxjs'
import apiResponse from '../../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'

class IndexBloc {

    workUnitChannel = new Subject();
    EmployeeStatusChannel = new Subject();
    indexChannel = new Subject()
    detailChannel = new Subject();
    rowtableChannel = new Subject();
    typeChannel = new Subject();
    childTypeChannel = new Subject();
    signatoriesChannel = new Subject();
    approvalChannel = new Subject();
    kuotaChannel = new Subject();
    minDateChannel = new Subject();
    repository = new IndexRepository()

    constructor() {
        this.indexChannel.next({status: apiResponse.INITIAL})
        this.detailChannel.next({ status: apiResponse.INITIAL })
        this.rowtableChannel.next({ status: apiResponse.INITIAL })
        this.signatoriesChannel.next({ status: apiResponse.INITIAL })
        this.typeChannel.next({status: apiResponse.INITIAL })
        this.childTypeChannel.next({status: apiResponse.INITIAL })
        this.kuotaChannel.next({ status: apiResponse.INITIAL })
        this.approvalChannel.next({ status: apiResponse.INITIAL })
        this.minDateChannel.next({ status: apiResponse.INITIAL })
    }

    fetchKuotaTahunan = async (query) => {
        try {
            this.kuotaChannel.next({  status: apiResponse.LOADING })
            await this.repository.fetchKuotaTahunan(query).then((result) => {
                this.kuotaChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.kuotaChannel.next({ status: apiResponse.ERROR, data: error })
            })           
        } catch (error) {
            console.log('rxjs Unsubscribed')        
        }
    }

    fetchWorkUnit = async (query) => {
        try {
            this.workUnitChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchWorkUnit(query).then((result) => {
                this.workUnitChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.workUnitChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('rxjs Unsubscribed')
        }
    }
    fetchEmployeeStatus = async (query) => {
        try {
            this.EmployeeStatusChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEmployeeStatus(query).then((result) => {
                this.EmployeeStatusChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.EmployeeStatusChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs Unsubscribed')
        }
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchRowTable = async (query, cancelToken) => {
        try {
            this.rowtableChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTable(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchTypeList = async (query) => {
        try {
            this.typeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchTypeList(query).then((result) => {
                this.typeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.typeChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('rxjs', 'Subject Unsubscribed')
        }
    }

    fetchChildTypeList = async (query) => {
        try {
            this.childTypeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchChildTypeList(query).then((result) => {
                this.childTypeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.childTypeChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('rxjs', 'Subject Unsubscribed')
        }
    }

    fetchSignatoriesList = async (query) => {
        this.signatoriesChannel.next({status: apiResponse.INITIAL})
        try {
            await this.repository.fetchSignatoriesList(query).then((result) => {
                this.signatoriesChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.signatoriesChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchApproval = async (query) => {
        this.approvalChannel.next({status: apiResponse.INITIAL})
        try {
            await this.repository.fetchApproval(query).then((result) => {
                this.approvalChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.approvalChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchMinDate = async (query) => {
        try {
            this.minDateChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchMinDate(query).then((result) => {
                this.minDateChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.minDateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }


}

export default IndexBloc